// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Firebase конфигурация
const firebaseConfig = {
  apiKey: "AIzaSyA1LxXkisA4G0sXJVMJDDnm9WgmscxV-0o",
  authDomain: "studio-central-9b7c5.firebaseapp.com",
  projectId: "studio-central-9b7c5",
  storageBucket: "studio-central-9b7c5.firebasestorage.app",
  messagingSenderId: "873919594062",
  appId: "1:873919594062:web:a81d05007701ae72524d1f",
  measurementId: "G-DZGSV6685W"
};

// Инициализация на Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Експортираме Firestore
export const db = getFirestore(app);
